import { BADGE_STATUS } from '~/app/enums/BadgeStatus';

export default function useStatusBackgroundColour(status: string): string {
    switch (status) {
        case BADGE_STATUS.GRADIENT:
            return 'bg-ai-gradient text-white bg-[length:200%_200%] animate-ai-gradient';
        // Neutral #e4e4e7 / text #52525b
        case BADGE_STATUS.DRAFT:
        case BADGE_STATUS.PENDING:
        case BADGE_STATUS.NULL:
        case BADGE_STATUS.ARCHIVED:
        case BADGE_STATUS.TO_PAY:
            return 'bg-badgestatus-gray text-zinc-600';
        // Warning #fff2cc / text #997500
        case BADGE_STATUS.DUE:
        case BADGE_STATUS.WARNING:
        case BADGE_STATUS.VALIDATION_REQUESTED:
        case BADGE_STATUS.RESERVES_RAISED_AWAITING_CLIENT_SIGNATURE:
        case BADGE_STATUS.RESERVES_RAISED_AWAITING_TENANT_SIGNATURE:
        case BADGE_STATUS.RESERVES_RAISED_TENANT_SIGNATURE:
        case BADGE_STATUS.RESERVES_REMOVED_AWAITING_CLIENT_SIGNATURE:
        case BADGE_STATUS.COMPLETED_AWAITING_TENANT_SIGNATURE:
            return 'bg-badgestatus-orange text-[#997500]';
        // Progress #FFF3CE
        case BADGE_STATUS.ONGOING:
        case BADGE_STATUS.IN_PROGRESS:
            return 'bg-badgestatus-yellow text-statistics-yellow';
        // Information #bfdbfe / text #1e3a8a
        case BADGE_STATUS.SENT:
        case BADGE_STATUS.PROCESSED:
            return 'bg-badgestatus-blue text-blue-900';
        // Success #d4f0e3 / text #154937
        case BADGE_STATUS.ACCEPTED:
        case BADGE_STATUS.PAID:
        case BADGE_STATUS.DELIVERED:
        case BADGE_STATUS.SUCCESS:
        case BADGE_STATUS.VALIDATED:
        case BADGE_STATUS.COMPLETED:
        case BADGE_STATUS.DONE:
            return 'bg-badgestatus-green text-[#154937]';
        // Error #fee2e2 / text #b91c1c
        case BADGE_STATUS.LATE:
        case BADGE_STATUS.OVERDUE:
        case BADGE_STATUS.REFUSED:
        case BADGE_STATUS.FAILED:
        case BADGE_STATUS.EXTERNAL_FAILURE:
        case BADGE_STATUS.INTERNAL_FAILURE:
        case BADGE_STATUS.ERROR:
        case BADGE_STATUS.IS_LATE:
            return 'bg-badgestatus-red text-red-700';
        // Default: neutral pill #e4e4e7 / text #52525b
        default:
            return 'bg-badgestatus-gray text-zinc-600';
    }
}
